import React from "react";
import { injectIntl } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import PropTypes from "prop-types";

const BasicTable = ({ headings, data, noData, programs, ...props }) => {
  const useStyles = makeStyles({
    customTableContainer: {
      overflowX: "initial",
    },
    table: {
      width: '100%',
     // minWidth: 625,
      textAlign: "center",
    },
    tableHead: {
      height: "52px",
      minHeight: "52px",
    },
    tableRow: {
      minHeight: "52px",
      height: "52px",
      "&:nth-of-type(even)": {
        backgroundColor: "#fff",
      },
      "&:nth-of-type(odd)": {
        backgroundColor: "rgba(231, 231, 231, 0.5)",
      },
    },
    tableCell: {
      textAlign: "center",
      minWidth: "50px",
      maxWidth: "200px",
      padding: "8px",
    },
  });
  const classes = useStyles();
 // const lang = localStorage.getItem("lang");
  return (
    <TableContainer classes={{ root: classes.customTableContainer }}>
      <Table
        stickyHeader={props.stickyHeader}
        className={`${classes.table} ${props.tableClass} ${programs && "programs"}`}
        aria-label="simple table"
      >
        {headings?.length ? (
          <TableHead className={`${classes.tableHead} ${props.headClass}`}>
            <TableRow className={`${classes.tableRow} bg-white`}>
              {headings.map((head, ind) => (
                <TableCell
                  key={ind}
                  className={`${classes.tableCell} 'text-center' primaryColor`}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        ) : null}
        {data?.length ? (
          <TableBody>
            {data?.map((row, ind) => (
              <TableRow key={ind} className={`${classes.tableRow}`}>
                {row?.map((cell, ind) => (
                  <TableCell key={ind} className={classes.tableCell} 
                  //style={ programs ? lang === 'ar' ? {textAlign: 'right'} : {textAlign: 'left'} : {} }
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        ) : noData ? (
          <TableBody>
            <TableRow>
              <TableCell align="center" colSpan="12">
                {noData}
              </TableCell>
            </TableRow>
          </TableBody>
        ) : null}
      </Table>
    </TableContainer>
  );
};
export default injectIntl(BasicTable);
BasicTable.prototypes = {
  headings: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
};
//example
// const headings=[
//     'id',
//     'user name'
// ]
// const data =[
//     [1,'s'],[2,'ss']
// ]
